import React, { Children } from 'react';
import Table from 'react-bootstrap/Table';
import qs from 'qs';
import { useEffect, useState } from 'react';
import '../../css/_reportTable.scss';
import ReportFilter from './reportFilter';
import Loading from 'components/loading';
import { Pagination, Spin } from 'antd';

const ReportTable = ({ columns, dataSource, loading, pagination }) => {
  return (
    <>
      <Spin spinning={loading}>
        <div className="TabellaContainer custom-scroll ">
          {/* {loading ? <Loading flex={true} /> : ''} */}
          <Table striped bordered className="Tabella">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th className="Theader" key={column.key}>
                    <div className="filters">
                      <ReportFilter title="Filtri" obj={column.key} />
                    </div>
                    <div>{column.titleName}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dataSource.map((e) => {
                delete e.key;
                const cells = Object.keys(e).map((key) => {
                  return <td key={key}>{e[key]}</td>;
                });
                return <tr>{cells}</tr>;
              })}
            </tbody>
          </Table>
        </div>
        {pagination && <Pagination className="paginationReport" {...pagination} />}
      </Spin>
    </>
  );
};

export default ReportTable;
